import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { ScrollToTop } from "./components";
import configureStore from "./store/configureStore";
import routes from "./routes";
import "./css/index.scss";

const store = configureStore();

ReactDOM.render(
  <Provider store={store} key="provider">
    <BrowserRouter>
      <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js